import {useState} from 'react'
import GoodsReturnInvoiceForm from './GoodsReturnInvoiceForm';
import GoodsReturnInvoiceLisview from './GoodsReturnInvoiceLisview';

const ReturnInvoice = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <GoodsReturnInvoiceForm addForm={setFromIsShown} update={upData}   sId={serviceId}/>
        ) : (
          <GoodsReturnInvoiceLisview addForm={setFromIsShown} update={setUpData}   sId={setServiceId} />
        )}
      </>
  )
}

export default ReturnInvoice